import React from 'react';
function Sparkles({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m12 3-1.91 5.81A2 2 0 0 1 8.8 10.1L3 12l5.81 1.91a2 2 0 0 1 1.28 1.28L12 21l1.91-5.81a2 2 0 0 1 1.28-1.28L21 12l-5.81-1.91A2 2 0 0 1 13.9 8.8L12 3ZM5 3v4M19 17v4M3 5h4M17 19h4"
      />
    </svg>
  );
}

export default Sparkles;
